<template>
  <div>
    <div class="coverage-row">
      <h4>Coverage options:</h4>

      <div class="coverage-inputs">
        <v-text-field
          label="Coverage"
          v-for="(field, k) in quotes.coverages"
          :key="k"
          hide-details
          v-model="quotes.coverages[k]"
          class="coverage-input"
          @input="onInputChange(k)"
        />
      </div>
    </div>

    <v-row class="mt-4">
      <v-col>
        <v-select
          :items="baseData.terms"
          item-text="name"
          item-value="code"
          menu-props="auto"
          label="Product Type"
          v-model="quotes.termLength"
          @change="onTermSelectChange"
        />
      </v-col>

      <v-col>
        <v-select
          v-if="quotes.termLength === 'fex'"
          :items="baseData.fexRateClass"
          itemText="name"
          itemValue="code"
          label="Rate Class"
          menu-props="auto"
          v-model="quotes.rateClass"
          @change="onSelectChange"
        />
        <v-select
          v-else
          :items="baseData.rateClass"
          itemText="name"
          itemValue="code"
          label="Rate Class"
          menu-props="auto"
          v-model="quotes.rateClass"
          @change="onSelectChange"
        />
      </v-col>

      <v-col>
        <v-select
          label="Company"
          itemText="body"
          itemValue="code"
          :items="baseData.quoter_companies"
          v-model="quotes.company"
          @change="onSelectChange"
          menu-props="auto"
        />
      </v-col>

      <v-col>
        <v-switch
          inset
          label="Nicotine use"
          v-model="quotes.nicotine"
          @change="onSelectChange"
        />
      </v-col>
    </v-row>

    <h4 class="mb-4">Results:</h4>

    <div class="d-flex justify-space-between">
      <div
        class="coverage-result"
        v-for="(quote, k) in compareQuotesList"
        :key="k"
      >
        <div>${{ quote.price }}/mo</div>
        <div>{{ quote.amount }}</div>
        <div>{{ quote.coverage }}</div>
        <v-btn class="mt-2" color="primary">
          Apply for this product
          <v-icon right dark> mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuotesCompare',
  props: {
    baseData: Object,
    lead: Object,
  },
  data: () => ({
    isLoading: null,
    timer: null,

    quotes: {
      //default query params for quoter
      company: null,
      nicotine: false,
      rateClass: 'sp',
      termLength: '10',

      coverages: Array(3).fill(0),
    },
    compareQuotesList: Array(3).fill({
      price: '0',
      amount: 'Face Amount',
      coverage: '-',
    }),
  }),
  methods: {
    async onInputChange(quoteId) {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        // this.loadPrime();

        try {
          const { data } = await this.$axios.post(`/lead/get-quote`, {
            birthdate: this.lead.birth_date,
            state: this.lead.state,
            gender: this.lead.gender,
            smoker: this.quotes.nicotine,
            coverage: this.quotes.coverages[quoteId],
            term: this.quotes.termLength,
            rate_class: this.quotes.rateClass,
            company:
              this.quotes.company ?? this.baseData.quoter_companies[0].code,
          });

          this.compareQuotesList = this.compareQuotesList.map((quote, idx) => {
            if (idx === quoteId) {
              return {
                ...quote,
                price: data?.premium_monthly || '-',
                coverage: `$${data?.coverage || ' -'}`,
              };
            }
            return quote;
          });
        } catch (error) {
          console.log(error);
        } finally {
          this.isLoading = false;
        }
      }, 300);
    },
    async onSelectChange() {
      const quotesPromises = [];

      await this.compareQuotesList.forEach((item, index) => {
        quotesPromises.push(
          this.$axios
            .post(`/lead/get-quote`, {
              birthdate: this.lead.birth_date,
              state: this.lead.state,
              gender: this.lead.gender,
              smoker: this.quotes.nicotine,
              coverage: this.quotes.coverages[index],
              term: this.quotes.termLength,
              rate_class: this.quotes.rateClass,
              company:
                this.quotes.company ?? this.baseData.quoter_companies[0].code,
            })
            .then(({ data }) => {
              this.compareQuotesList = this.compareQuotesList.map(
                (quote, idx) => {
                  if (idx === index) {
                    return {
                      ...quote,
                      price: data?.premium_monthly || '-',
                      coverage: `$${data?.coverage || '-'}`,
                    };
                  }
                  return quote;
                }
              );
            })
        );
      });

      await Promise.all(quotesPromises);
    },
    async onTermSelectChange(val) {
      console.log(val);

      const isWrongRate = this.baseData.fexRateClass.find(
        (i) => i.code === this.quotes.rateClass
      );

      if (val === 'fex') {
        this.quotes.rateClass = this.baseData.fexRateClass[0].code;
      }

      if (isWrongRate) {
        this.quotes.rateClass = this.baseData.rateClass[0].code;
      }

      await this.onSelectChange();
    },
  },
};
</script>

<style scoped>
.coverage-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  gap: 40px;
}

.coverage-inputs {
  display: flex;
  gap: 15px;
}

.coverage-input {
  flex: 0 0 150px;
  padding-top: 0;
  margin-top: 4px;
}

.coverage-result {
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: center;
}
</style>